export const videosDb = [
  {
  "id": 1,
  "_id": "SUelbSa-OkA",
    "videoTitle":
      "LIFE BEYOND: Chapter 1. Alien life, deep time, and our place in cosmic history (4K)    ",
    "views": 10867712,
    "date": "Nov 20, 2019",
    "channel": {
      "cId": 2,
      "name": "melodysheep",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQX01z9397d0IgR7uW_Spo6odKET6mPUe0ChNb5cg=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 2,
  "_id": "uzkD5SeuwzM",
    "videoTitle":
      "TRUE Limits Of Humanity – The Final Border We Will Never Cross",
    "views": 13792104,
    "date": "May 11, 2021",
    "channel": {
      "cId": 1,
      "name": "Kurzgesagt - In a Nutshell",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQO2-DfuqwtPYTqBcZ8rEWt8g4p1sB_LyddKS5msQ=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 3,
  "_id": "saWNMPL5ygk",
    "videoTitle":
      "LIFE BEYOND 3: In Search of Giants. The Hunt for Intelligent Alien Life (4K)    ",
    "views": 3820918,
    "date": "Dec 7, 2021",
    "channel": {
      "cId": 2,
      "name": "melodysheep",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQX01z9397d0IgR7uW_Spo6odKET6mPUe0ChNb5cg=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 4,
  "_id": "ThDYazipjSI",
    "videoTitle": "LIFE BEYOND II: The Museum of Alien Life (4K)",
    "views": 15555869,
    "date": "Oct 7, 2020",
    "channel": {
      "cId": 2,
      "name": "melodysheep",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQX01z9397d0IgR7uW_Spo6odKET6mPUe0ChNb5cg=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 5,
  "_id": "_1R_pg5QasA",
    "videoTitle": "When Will COVID End?",
    "views": 3124896,
    "date": "Jan 19, 2022",
    "channel": {
      "cId": 3,
      "name": "AsapSCIENCE",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLSrnSwLN83-A6pQxTI-8kQkadSueJ0iMeltGiGnTA=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 6,
  "_id": "6SrsZVdU740",
    "videoTitle": "The Secret History of the Moon - 4K",
    "views": 1712043,
    "date": "Apr 30, 2020",
    "channel": {
      "cId": 2,
      "name": "melodysheep",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQX01z9397d0IgR7uW_Spo6odKET6mPUe0ChNb5cg=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 7,
  "_id": "uD4izuDMUQA",
    "videoTitle": "TIMELAPSE OF THE FUTURE: A Journey to the End of Time (4K)",
    "views": 78439473,
    "date": "Mar 20, 2019",
    "channel": {
      "cId": 2,
      "name": "melodysheep",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQX01z9397d0IgR7uW_Spo6odKET6mPUe0ChNb5cg=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 8,
  "_id": "dFCbJmgeHmA",
    "videoTitle": "The Day the Dinosaurs Died – Minute by Minute    ",
    "views": 13060384,
    "date": "Jun 15, 2021",
    "channel": {
      "cId": 1,
      "name": "Kurzgesagt - In a Nutshell",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQO2-DfuqwtPYTqBcZ8rEWt8g4p1sB_LyddKS5msQ=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 9,
  "_id": "BickMFHAZR0",
    "videoTitle": "How Trees Bend the Laws of Physics    ",
    "views": 4017528,
    "date": "Oct 30, 2012",
    "channel": {
      "cId": 4,
      "name": "Veritasium",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQYcLqrGZC1RZL4e1AFz5-ImMQmmgObvzWBCL7-mA=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 10,
  "_id": "tH2tKigOPBU",
    "videoTitle": "Perseverance Mars Rover Landing- Inside Story    ",
    "views": 13658884,
    "date": "Feb 15, 2021",
    "channel": {
      "cId": 5,
      "name": "Mark Rober",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLROoLxOPO5oOgstWUmtYIEryw050SUJWHptwGWh=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 11,
  "_id": "DTvS9lvRxZ8",
    "videoTitle": "Backyard Squirrel Maze 2.0- The Walnut Heist    ",
    "views": 53384203,
    "date": "May 19, 2021",
    "channel": {
      "cId": 5,
      "name": "Mark Rober",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLROoLxOPO5oOgstWUmtYIEryw050SUJWHptwGWh=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 12,
  "_id": "xaQJbozY_Is",
    "videoTitle": "What Dinosaurs ACTUALLY Looked Like?    ",
    "views": 8706402,
    "date": "Oct 12, 2021",
    "channel": {
      "cId": 1,
      "name": "Kurzgesagt - In a Nutshell",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQO2-DfuqwtPYTqBcZ8rEWt8g4p1sB_LyddKS5msQ=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 13,
  "_id": "e-P5IFTqB98",
    "videoTitle": "Black Holes Explained – From Birth to Death    ",
    "views": 19347752,
    "date": "Dec 15, 2015",
    "channel": {
      "cId": 1,
      "name": "Kurzgesagt - In a Nutshell",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQO2-DfuqwtPYTqBcZ8rEWt8g4p1sB_LyddKS5msQ=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 14,
  "_id": "pP44EPBMb8A",
    "videoTitle": "How to Build a Dyson Sphere - The Ultimate Megastructure    ",
    "views": 17889672,
    "date": "Dec 20, 2018",
    "channel": {
      "cId": 1,
      "name": "Kurzgesagt - In a Nutshell",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQO2-DfuqwtPYTqBcZ8rEWt8g4p1sB_LyddKS5msQ=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 15,
  "_id": "NtQkz0aRDe8",
    "videoTitle":
      "How We Could Build a Moon Base TODAY – Space Colonization 1    ",
    "views": 13286914,
    "date": "Sep 16, 2018",
    "channel": {
      "cId": 1,
      "name": "Kurzgesagt - In a Nutshell",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLQO2-DfuqwtPYTqBcZ8rEWt8g4p1sB_LyddKS5msQ=s88-c-k-c0x00ffffff-no-rj",
    },
  },

  {
  "id": 16,
  "_id": "lARpY0nIQx0",
    "videoTitle": "Is NASA a waste of money?    ",
    "views": 13588839,
    "date": "Feb 15, 2018",
    "channel": {
      "cId": 5,
      "name": "Mark Rober",
      "logo": "https://yt3.ggpht.com/ytc/AKedOLROoLxOPO5oOgstWUmtYIEryw050SUJWHptwGWh=s88-c-k-c0x00ffffff-no-rj",
    },
  },
];

// https://www.youtube.com/watch?v=DTvS9lvRxZ8
// https://www.youtube.com/watch?v=wNDGgL73ihY
// https://www.youtube.com/watch?v=e-P5IFTqB98
// https://www.youtube.com/watch?v=pP44EPBMb8A
// https://www.youtube.com/watch?v=NtQkz0aRDe8
// https://www.youtube.com/watch?v=lARpY0nIQx0
// https://www.youtube.com/watch?v=_1R_pg5QasA
